"use strict";

import * as CollectionGrid from "components/CollectionGrid";
import * as Modals from "components/Modals";
import * as Selects from "components/Selects"; // Collection page styles
document.addEventListener("DOMContentLoaded", function () {
  CollectionGrid.init();
  Modals.init();
  Selects.init();
});
